export const TAGS = [
  "Прокачай<br/>командные навыки",
  "Попади на стажировку<br/>в ведущие компании",
  "Сделай первый шаг<br/>в мир технологий",
  "Выиграй денежные<br/> или ценные призы",
  "Стань частью<br/>технологического сообщества",
  "Получи бонусы при<br/>поступлении в магистратуру",
  "Заработай 100 баллов ЕГЭ<br/>или поступи БВИ в вуз мечты",
];

export const NTO_GOALS = [
  "Олимпиада помогает школьникам и&nbsp;студентам знакомиться с&nbsp;инженерными профессиями.",
  "НТО&nbsp;&mdash; это безопасное пространство для роста, экспериментов и&nbsp;смелых открытий.",
  "Мы&nbsp;не&nbsp;ищем готовые таланты, а&nbsp;создаём условия, в&nbsp;которых они рождаются.",
  "Ты&nbsp;не&nbsp;просто участник&nbsp;&mdash; ты&nbsp;будущий создатель решений, которые изменят мир.",
];

export const ABOUT_NTO = [
  {
    count: 7,
    cellHeader: "",
    cellFooter: ["Сфер", "для школьников<br />5-7 классов"],
  },
  {
    count: 30,
    cellHeader: "+",
    cellFooter: ["Направлений", "для школьников<br />8-11 классов"],
  },
  {
    count: 5,
    cellHeader: "",
    cellFooter: ["Профилей", "для студентов<br />колледжей и&nbsp;вузов"],
  },
];

export const TRACKS = [
  {
    src: require("@/assets/images/landing/participants/icon_punched-card1.svg"),
    title: "НТО Юниоры",
    for: "Для учеников 5&minus;7 классов",
    list: [
      "Первые шаги в&nbsp;мир передовых технологий",
      "Опыт командной работы",
      "Подготовка к&nbsp;старшему треку НТО",
    ],
    link: "https://junior.ntcontest.ru/",
  },

  {
    src: require("@/assets/images/landing/participants/icon_punched-card2.svg"),
    title: "НТО: старший трек",
    for: "Для учеников 8&minus;11 классов и&nbsp;студентов 1&minus;2 курсов СПО на&nbsp;базе 9&nbsp;класса",
    list: [
      "Льготы при поступлении",
      "Знакомство с&nbsp;профессиями",
      "Портфолио достижений",
      "Создание хорошего фундамента для старта карьеры",
    ],
    link: "https://ntcontest.ru/tracks/nto-school/",
  },
  {
    src: require("@/assets/images/landing/participants/icon_punched-card3.svg"),
    title: "НТО студентов",
    for: "Для студентов колледжей и&nbsp;вузов",
    list: [
      "Реальные задачи отрасли",
      "Приглашения на стажировки",
      "Бонусы при поступлении в магистратуру",
      "Новые знакомства и единомышленники",
    ],
    link: "https://ntcontest.ru/tracks/nto-student/",
  },
];

export const BONUSES = [
  {
    src: require("@/assets/images/landing/extras/icon_violet.svg"),
    title: "Бонусы для участников прошлых лет",
    description:
      "Финалисты, победители и&nbsp;призеры прошлого сезона получают привилегии: <b class='text-bold'>дополнительные баллы на&nbsp;отборочных этапах</b> в&nbsp;НТО для 8-11 классов и&nbsp;НТО Юниоры, проход во&nbsp;II отборочный этап или даже напрямую в&nbsp;финал своего профиля. Подробности&nbsp;&mdash; в&nbsp;личном кабинете.",
  },
  {
    src: require("@/assets/images/landing/extras/icon_red.svg"),
    title: "Бонусы за&nbsp;нормативы ТехноГТО",
    description:
      "Сдав нормативы ТехноГТО этой осенью, можно получить дополнительные баллы на&nbsp;отборочном этапе:",
    details: [
      {
        title: "НТО Юниоры",
        description:
          "<b class='text-bold'>+1&nbsp;балл</b> за&nbsp;каждый<br />сданный норматив",
      },
      {
        title: "НТО для 8-11",
        description:
          "<b class='text-bold'>+2&nbsp;балла</b> за&nbsp;каждый<br />сданный норматив",
      },
    ],
  },
  {
    src: require("@/assets/images/landing/extras/icon_blue_light.svg"),
    title: "Конкурс &laquo;Талант НТО&raquo;",
    description:
      "Достижения на&nbsp;НТО за&nbsp;все годы учитываются в&nbsp;конкурсе цифровых портфолио &laquo;Талант НТО&raquo;. В&nbsp;ряде вузов дипломы призеров и&nbsp;победителей конкурса учитываются как индивидуальные достижения и&nbsp;дают дополнительные баллы при поступлении.",
  },
  {
    src: require("@/assets/images/landing/extras/icon_green.svg"),
    title: "Приглашение наставника",
    description:
      "Пригласите своего наставника зарегистрироваться и&nbsp;создать личный кабинет. В&nbsp;личном кабинете ему будет проще следить за&nbsp;вашим прогрессом и&nbsp;поддерживать вас на&nbsp;каждом этапе соревнований.",
  },
];
